<div class="modal-content">
    <div class="modal-header text-center">

    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/alert.svg">
        <h3 class="mt-2">¡Lo sentimos!</h3>
        <hr class="w-50 mx-auto">
        <h6 class="mt-2">Se ha agotado el tiempo de llamado</h6>
    </div>
    <div class="modal-footer">
        <div class="row mx-auto">
            <h6>¿Desea anular el turno?</h6>
        </div>
        <div class="row mx-auto">
            <div class="col-6">
                <button type="button" class="btn-conf" (click)="respuesta(true)">SI</button>
            </div>
            <div class="col-6">
                <button type="button" class="btn-canc" (click)="respuesta(false)">NO</button>
            </div>
        </div>

    </div>
</div>
